import { Info, Link as LinkIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { PageHeader } from "@/components/shared";
import { ReferralLevelPanel } from "@/components/admin/ReferralLevelPanel";
import { ReferralType } from "@/types/enums";

const LevelSettingsSection = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <PageHeader
        title={t("referrals.title")}
        description={t("referrals.subtitle")}
      />

      <Alert className="py-2.5">
        <Info className="h-4 w-4" />
        <AlertDescription className="text-xs">
          {t("referrals.cashback_info")}
        </AlertDescription>
      </Alert>

      <Card>
        <CardHeader className="p-4 pb-2">
          <div className="flex items-center gap-2">
            <LinkIcon className="h-4 w-4 text-accent" />
            <CardTitle className="text-base">Level Configuration</CardTitle>
          </div>
          <CardDescription>
            Create any number of levels and assign commission %. Use Add Level, then edit or delete as needed.
          </CardDescription>
        </CardHeader>
        <CardContent className="p-4 pt-0">
          <Tabs defaultValue="user">
            <TabsList>
              <TabsTrigger value="user">Customer</TabsTrigger>
              <TabsTrigger value="store">Store</TabsTrigger>
            </TabsList>
            <TabsContent value="user" className="mt-4">
              <ReferralLevelPanel type={ReferralType.User} />
            </TabsContent>
            <TabsContent value="store" className="mt-4">
              <ReferralLevelPanel type={ReferralType.Store} />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};

export default LevelSettingsSection;
